import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { useTimezoneStore } from '@/store/timezoneStore';
import { TextField } from '@mui/material';
import moment from 'moment-timezone';

interface LocalizedDateTimeInputProps {
  label: string;
  [key: string]: any;
}

export const LocalizedDateTimePicker = ({
  label,
  value,
  onChange,
  ...props
}: LocalizedDateTimeInputProps) => {
  const { timezone, locale } = useTimezoneStore();

  // Convert the incoming value to the selected timezone for display
  const localizedValue = value ? moment.tz(value, timezone) : null;

  // Handle onChange - convert back to UTC ISO string
  const handleChange = (newValue: moment.Moment | null) => {
    if (newValue && onChange) {
      // Convert picked value in local timezone to UTC ISO string
      const utcValue = moment
        .tz(newValue.format('YYYY-MM-DD HH:mm:ss'), timezone)
        .utc()
        .toISOString();
      onChange(utcValue);
    } else if (onChange) {
      onChange(null);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={locale}>
      <DateTimePicker
        label={`${label} (${timezone})`}
        value={localizedValue}
        onChange={handleChange}
        renderInput={(params) => <TextField {...params} />}
        {...props}
      />
    </LocalizationProvider>
  );
};
